window.LA1970_DECORATION_CONFIG = {
  vatRate: 0.22,

  general: {
    otherSizesOnRequest: true,
    otherQuantitiesOnRequest: true
  },

  prices: {
    dtf_textile: {
      small: 3.20,
      medium: 3.70,
      large: 4.60,
      xl: 4.90
    },

    dtf_umbrella: {
      small: 2.95,
      large: 3.50
    },

    embroidery: {
      chest: 3.80,
      backSmall: 8.00,
      backLarge: 12.00
    },

    laser: {
      small: 2.08,
      medium: 2.47,
      large: 2.73,
      textile: 6.05
    },

    embossing: {
      price: 10.00,
      minQty: 100,
      plateOnRequest: true
    },

    digitalPrint: {
      onRequest: true
    },

    sticker3d: {
      standard: 2.70
    },

    patch: {
      standard: 4.30,
      rubber3d: 4.50
    }
  },

  profiles: {
    textile_standard: {
      methods: [
        "DTF",
        "Stick",
        "Digitaldruck"
      ],

      positions: [
        "chest_left",
        "chest_right",
        "chest_center",
        "back_small",
        "back_large",
        "sleeve_left",
        "sleeve_right"
      ]
    },

    jacket_standard: {
      methods: [
        "DTF",
        "Stick",
        "Digitaldruck",
        "Lasergravur"
      ],

      positions: [
        "chest_left",
        "chest_right",
        "back_small",
        "back_large",
        "sleeve_left",
        "sleeve_right"
      ]
    },

    trouser_standard: {
      methods: [
        "DTF",
        "Stick"
      ],

      positions: [
        "leg_left",
        "leg_right"
      ]
    },

    cap_standard: {
      methods: [
        "Stick",
        "DTF",
        "Embossing",
        "3D-Sticker",
        "Patch"
      ],

      positions: [
        "cap_front",
        "cap_left",
        "cap_right",
        "cap_back"
      ],

      maxFrontWidthCm: 12,
      maxFrontHeightCm: 6
    },

    umbrella_standard: {
      methods: [
        "DTF",
        "Digitaldruck"
      ],

      positions: [
        "umbrella_panel"
      ],

      dtfSizes: {
        small: {
          widthCm: 10,
          heightCm: 10,
          price: 2.95
        },

        large: {
          widthCm: 15,
          heightCm: 15,
          price: 3.50
        }
      }
    },

    hardgoods_standard: {
      methods: [
        "Lasergravur",
        "Digitaldruck",
        "Embossing",
        "3D-Sticker",
        "Patch"
      ],

      positions: [
        "front",
        "back",
        "side"
      ]
    }
  },

  categoryProfiles: {
    "t-shirt": "textile_standard",
    "t-shirts": "textile_standard",
    "polo": "textile_standard",
    "polos": "textile_standard",
    "hoodie": "textile_standard",
    "hoodies": "textile_standard",
    "sweatshirt": "textile_standard",
    "sweatshirts": "textile_standard",
    "hemd": "textile_standard",
    "hemden": "textile_standard",
    "bluse": "textile_standard",
    "blusen": "textile_standard",
    "fleece": "jacket_standard",
    "jacke": "jacket_standard",
    "jacken": "jacket_standard",
    "softshell": "jacket_standard",
    "weste": "jacket_standard",
    "westen": "jacket_standard",
    "hose": "trouser_standard",
    "hosen": "trouser_standard",
    "shorts": "trouser_standard",
    "cap": "cap_standard",
    "caps": "cap_standard",
    "schirm": "umbrella_standard",
    "schirme": "umbrella_standard",
    "regenschirm": "umbrella_standard",
    "regenschirme": "umbrella_standard",

    "flasche": "hardgoods_standard",
    "flaschen": "hardgoods_standard",
    "trinkflasche": "hardgoods_standard",
    "trinkflaschen": "hardgoods_standard",
    "bottle": "hardgoods_standard",
    "bottles": "hardgoods_standard",

    "becher": "hardgoods_standard",
    "tasse": "hardgoods_standard",
    "tassen": "hardgoods_standard",
    "thermobecher": "hardgoods_standard",
    "mug": "hardgoods_standard",
    "mugs": "hardgoods_standard",
    "cup": "hardgoods_standard",
    "cups": "hardgoods_standard",

    "werbeartikel": "hardgoods_standard"
  }
};

window.LA1970_DECORATION_DISCOUNTS = {
  tiers: [
    { min: 1, max: 99, discount: 0 },
    { min: 100, max: 249, discount: 0.05 },
    { min: 250, max: 499, discount: 0.10 },
    { min: 500, max: 999, discount: 0.15 },
    { min: 1000, max: 3000, discount: 0.20 }
  ],

  above3000OnRequest: true,

  applyToDecorationOnly: true,
  inheritShopifyCustomerDiscount: false
};

window.LA1970_DECORATION_SERVICE_VARIANTS = {
  dtf_small: {
    "1-99": 58564909302024,
    "100-249": 58564909334792,
    "250-499": 58564909367560,
    "500-999": 58564909400328,
    "1000-3000": 58564909433096
  },

  dtf_medium: {
    "1-99": 58565005574408,
    "100-249": 58565005607176,
    "250-499": 58565005639944,
    "500-999": 58565005672712,
    "1000-3000": 58565005705480
  },

  dtf_large: {
    "1-99": 58565005771016,
    "100-249": 58565005803784,
    "250-499": 58565005836552,
    "500-999": 58565005869320,
    "1000-3000": 58565005902088
  },

  dtf_xl: {
    "1-99": 58565005934856,
    "100-249": 58565005967624,
    "250-499": 58565006000392,
    "500-999": 58565006033160,
    "1000-3000": 58565006065928
  },

  dtf_umbrella_small: {
    "1-99": 58565006098696,
    "100-249": 58565006131464,
    "250-499": 58565006164232,
    "500-999": 58565006197000,
    "1000-3000": 58565006229768
  },

  dtf_umbrella_large: {
    "1-99": 58565006262536,
    "100-249": 58565006295304,
    "250-499": 58565006328072,
    "500-999": 58565006360840,
    "1000-3000": 58565006393608
  },

  embroidery_small: {
    "1-99": 58565006426376,
    "100-249": 58565006459144,
    "250-499": 58565006491912,
    "500-999": 58565006524680,
    "1000-3000": 58565006557448
  },

  embroidery_back_small: {
    "1-99": 58565006590216,
    "100-249": 58565006622984,
    "250-499": 58565006655752,
    "500-999": 58565006688520,
    "1000-3000": 58565006721288
  },

  embroidery_back_large: {
    "1-99": 58565006754056,
    "100-249": 58565006786824,
    "250-499": 58565006819592,
    "500-999": 58565006852360,
    "1000-3000": 58565006885128
  },

  laser_ad_small: {
    "1-99": 58565006917896,
    "100-249": 58565006950664,
    "250-499": 58565006983432,
    "500-999": 58565007016200,
    "1000-3000": 58565007048968
  },

  laser_ad_medium: {
    "1-99": 58565007081736,
    "100-249": 58565007114504,
    "250-499": 58565007147272,
    "500-999": 58565007180040,
    "1000-3000": 58565007212808
  },

  laser_ad_large: {
    "1-99": 58565007278344,
    "100-249": 58565007311112,
    "250-499": 58565007343880,
    "500-999": 58565007376648,
    "1000-3000": 58565007409416
  },

  laser_textile: {
    "1-99": 58565007442184,
    "100-249": 58565007474952,
    "250-499": 58565007507720,
    "500-999": 58565007540488,
    "1000-3000": 58565007573256
  },

  embossing: {
    "100-249": 58565007671560,
    "250-499": 58565007704328,
    "500-999": 58565007737096,
    "1000-3000": 58565007769864
  },

  sticker3d: {
    "1-99": 58565008064776,
    "100-249": 58565008097544,
    "250-499": 58565008130312,
    "500-999": 58565008163080,
    "1000-3000": 58565008195848
  },

  patch_standard: {
    "1-99": 58565008261384,
    "100-249": 58565008294152,
    "250-499": 58565008326920,
    "500-999": 58565008359688,
    "1000-3000": 58565008392456
  },

  patch_rubber3d: {
    "1-99": 58565008425224,
    "100-249": 58565008457992,
    "250-499": 58565008490760,
    "500-999": 58565008523528,
    "1000-3000": 58565008556296
  }
};


Object.assign(window.LA1970_DECORATION_SERVICE_VARIANTS,{"dtf_small_market": {"breaks": [{"min": 1, "max": 4, "id": 59185632903432, "net": 19.95, "gross": 24.34, "source": "BUNTWAESCHE"}, {"min": 5, "max": 9, "id": 59185632936200, "net": 15.52, "gross": 18.93, "source": "BUNTWAESCHE"}, {"min": 10, "max": 19, "id": 59185632968968, "net": 5.8, "gross": 7.08, "source": "UNICUM"}, {"min": 20, "max": 49, "id": 59185633001736, "net": 4.25, "gross": 5.19, "source": "UNICUM"}, {"min": 50, "max": 99, "id": 59185633034504, "net": 3.2, "gross": 3.9, "source": "UNICUM"}, {"min": 100, "max": 249, "id": 59185633067272, "net": 2.5, "gross": 3.05, "source": "UNICUM"}, {"min": 250, "max": 3000, "id": 59185633100040, "net": 1.9, "gross": 2.32, "source": "UNICUM"}]}, "dtf_medium_market": {"breaks": [{"min": 1, "max": 4, "id": 59185640997128, "net": 19.95, "gross": 24.34, "source": "BUNTWAESCHE"}, {"min": 5, "max": 9, "id": 59185641029896, "net": 16.33, "gross": 19.92, "source": "BUNTWAESCHE"}, {"min": 10, "max": 19, "id": 59185641062664, "net": 6.8, "gross": 8.3, "source": "UNICUM"}, {"min": 20, "max": 49, "id": 59185641095432, "net": 5.25, "gross": 6.41, "source": "UNICUM"}, {"min": 50, "max": 99, "id": 59185641128200, "net": 3.7, "gross": 4.51, "source": "UNICUM"}, {"min": 100, "max": 249, "id": 59185641160968, "net": 3, "gross": 3.66, "source": "UNICUM"}, {"min": 250, "max": 3000, "id": 59185641193736, "net": 2.5, "gross": 3.05, "source": "UNICUM"}]}, "dtf_large_market": {"breaks": [{"min": 1, "max": 4, "id": 59185647911176, "net": 19.95, "gross": 24.34, "source": "BUNTWAESCHE"}, {"min": 5, "max": 9, "id": 59185647943944, "net": 16.33, "gross": 19.92, "source": "BUNTWAESCHE"}, {"min": 10, "max": 19, "id": 59185647976712, "net": 7.6, "gross": 9.27, "source": "UNICUM"}, {"min": 20, "max": 49, "id": 59185648009480, "net": 5.9, "gross": 7.2, "source": "UNICUM"}, {"min": 50, "max": 99, "id": 59185648042248, "net": 4.6, "gross": 5.61, "source": "UNICUM"}, {"min": 100, "max": 249, "id": 59185648075016, "net": 3.9, "gross": 4.76, "source": "UNICUM"}, {"min": 250, "max": 3000, "id": 59185648107784, "net": 3.3, "gross": 4.03, "source": "UNICUM"}]}, "dtf_xl_market": {"breaks": [{"min": 1, "max": 4, "id": 59185653514504, "net": 19.95, "gross": 24.34, "source": "BUNTWAESCHE"}, {"min": 5, "max": 9, "id": 59185653547272, "net": 17.41, "gross": 21.24, "source": "BUNTWAESCHE"}, {"min": 10, "max": 19, "id": 59185653580040, "net": 9.5, "gross": 11.59, "source": "UNICUM"}, {"min": 20, "max": 49, "id": 59185653612808, "net": 8.1, "gross": 9.88, "source": "UNICUM"}, {"min": 50, "max": 99, "id": 59185653645576, "net": 4.9, "gross": 5.98, "source": "UNICUM"}, {"min": 100, "max": 249, "id": 59185653678344, "net": 4.1, "gross": 5, "source": "UNICUM"}, {"min": 250, "max": 3000, "id": 59185653711112, "net": 3.8, "gross": 4.64, "source": "UNICUM"}]}});
